import React, { useState } from 'react'
import { useController } from 'react-hook-form'
import FormHelperText from '@mui/material/FormHelperText'
import Grid from '@mui/material/Grid'
import TextField from '@mui/material/TextField'
import MenuItem from '@mui/material/MenuItem'
import { Chip, FormControl, InputLabel, Select, makeStyles } from '@material-ui/core'


const useStyles = makeStyles((theme) => ({
    formControl: {
        width: "100%",
    },
    chips: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    chip: {
        margin: 2,
    },
    noLabel: {
        marginTop: theme.spacing(3),
    },
    helperTxt: {
        color:"red"
    },
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

const Input = ({
    controllerProps,
    margin = 'normal',
    select,
    disabled,
    type,
    selectOptions,
    gridProps = {},
    ...props
}) => {
    const { field, fieldState: { error } } = useController({
        defaultValue: '',
        ...controllerProps,
    })
    const [valueDisplay, setValueDisplay] = useState([])
    const classes = useStyles();
    let children = [];
    let childrenMultiple = [];

    if (!controllerProps.conditionalFieldCondition) {
        controllerProps.conditionalFieldCondition=[]
    }

    if (select && selectOptions)
        children = selectOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
                {option.label}
            </MenuItem>
        ))
    
    if (select && selectOptions && controllerProps.multipleSelect) {
        
        childrenMultiple = selectOptions.map((option) => {
            // console.log(option)
            if (typeof (option) ==="object") {
                return (
                    <MenuItem key={option.value} value={option.value} disabled={option.disabled}>
                        {option.value}
                    </MenuItem>

                )
            } else {
                return (
                    <MenuItem key={option} value={option} >
                        {option}
                    </MenuItem>

                )
            }
           
        }) 

    }
       

    const onChange = (event) => {
        if (props.type === 'number') field.onChange(+event.target.value)
        else field.onChange(event.target.value)
    }

    const handleChange = (event) => {
        field.onChange(event.target.value);
        setValueDisplay(event.target.value);
    };

    function getAccessHelpMsg(id) {
        let result = selectOptions.filter(item => item.value === id)
        let retour = "";
        if (result.length > 0) {
            retour = result[0].infoSupp
        }
        return retour
    } 
   
    // console.log(controllerProps.name, error)

    return (
        controllerProps.multipleSelect ?
            <Grid item xs={12} md={6} {...gridProps}>
                <FormControl className={classes.formControl}>
                    <InputLabel>{props.label}</InputLabel>
                    <Select
                        variant="standard"
                        multiple
                        fullWidth
                        disabled={disabled}
                    value={valueDisplay}
                    onChange={handleChange}
                    // input={<Input id="select-multiple-chip" />}
                    renderValue={(selected) => (
                        <div className={classes.chips}>
                            {field.value.map((value) => (
                                <Chip color="primary" key={value} label={value} className={classes.chip} />
                            ))}
                        </div>
                    )}
                    MenuProps={MenuProps}
                    {...props}
                    {...field}
                    children={childrenMultiple}
                    />
                </FormControl>
            </Grid>
            :
        <Grid item xs={12} md={6} {...gridProps}>
            <TextField
                    required={controllerProps.rules ? controllerProps.rules.required : false}
                    error={error !== undefined}
                    margin={margin}
                    size="small"
                    fullWidth
                    disabled={disabled}
                    select={select}
                    {...props}
                    {...field}
                    onChange={onChange}
                    children={children}
                    type={type?type:"text"}
                />
                {(controllerProps.conditionalFieldCondition.indexOf(field.value) >= 0) && controllerProps.conditionalField[controllerProps.conditionalFieldCondition.indexOf(field.value)]}
                {controllerProps.helper && <FormHelperText className={classes.helperTxt}>{<span className={classes.helperTxt} dangerouslySetInnerHTML={{ __html: getAccessHelpMsg(field.value) }} />}</FormHelperText>}
                {error !== undefined && <FormHelperText style={{ color: "red" }}>{(error.type === "required") ? controllerProps.rules.errorMsg : error.message}</FormHelperText>}
        </Grid>
    )
}

export default Input
